
function WhatsApp() {
    return (
        <a
            className="wa-float"
            href="https://wa.me/51941175281"
            aria-label="WhatsApp"
            target="_blank"
            rel="noopener noreferrer"
        >
            <i className="fab fa-whatsapp"></i>
        </a>
    );
}

export default WhatsApp;